// vue-slider-component stacks its two range dots in DOM order with no explicit z-index, so when
// both handles land on the exact same value (e.g. a clip trimmed down to zero length against the
// end of the timeline) the second (end) dot always sits on top and silently swallows every click/
// drag meant for the first (start) dot - it becomes impossible to grab the one that's actually
// still able to move. Whichever dot is pinned against a min/max boundary can't move further in
// that direction anyway, so raising the z-index of the *other* one - the one that still has room
// to move - is what actually restores the ability to drag it back out of the overlap.
export const dotZIndexOptions = (range, min, max) => {
    if (range[0] === range[1]) {
        if (range[1] >= max) return [{ style: { zIndex: 3 } }, { style: { zIndex: 1 } }]
        if (range[0] <= min) return [{ style: { zIndex: 1 } }, { style: { zIndex: 3 } }]
    }
    return [{ style: { zIndex: 1 } }, { style: { zIndex: 1 } }]
}
